import Base64 from 'app/utils/helpers/base64.helpers'
import imageLoader from 'app/utils/helpers/imageLoader'

export const getSeoImageUrl = (avatarUrl?: string) => {
  if (!avatarUrl) return null

  const baseSrc = Base64.btoa(String(avatarUrl))

  return imageLoader({ src: baseSrc, width: 120 })
}
